<template>
  <div style="border: 1px solid #ccc; margin-top: 10px;">
    <!-- 工具栏 -->
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
    />
    <!-- 编辑器 -->
    <WangEditor
      :style="{height: height+'px',  overflowY: 'hidden'}"
      :defaultConfig="this.getEditorConfig()"
      v-model="currentValue"
      @onChange="onChange"
      @onCreated="onCreated"
    />
  </div>
</template>
<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";

export default {
  name: 'Editor',
  components: {
    'WangEditor': Editor,
    Toolbar
  },
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: undefined
    },
    /* 高度 */
    height: {
      type: Number,
      default: 300
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false
    },
    // 上传文件大小限制(MB)
    fileSize: {
      type: Number,
      default: 1024
    },
    imageSize: {
      type: Number,
      default: 20
    },
    videoSize: {
      type: Number,
      default: 1024
    }
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        //excludeKeys: ["codeBlock" ],
      },
      editorConfig: this.getEditorConfig(),
      currentValue: ''
    }
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        newValue = newValue === null || newValue === undefined ? '' : newValue
        this.valueChange(newValue);
        if (this.editor) {
          this.setContent(newValue);
        }
      }
    }
  },
  mounted() {
  },
  methods: {

    beforeDestroy() {
      console.log('editor 容器销毁')
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
    },
    getEditorConfig() {
      let that = this
      const editorConfig = {MENU_CONF: {}}
      editorConfig.MENU_CONF['uploadImage'] = {
        async customUpload(file, insertFn) {
          // 获取文件对象
          const uploadFile = file
          // 文件夹目录
          const prefix = 'text'
          const url = uploadOss(uploadFile.name, prefix)
          uploadObject(url, uploadFile).then(res => {
            insertFn(res, res, res)
          })
          const message = that.$t('通用.文本.上传成功')
          that.$message.success(message)
        }
      }
      editorConfig.MENU_CONF['uploadVideo'] = {
        async customUpload(file, insertFn) {
          // 获取文件对象
          const uploadFile = file
          // 文件夹目录
          const prefix = 'text'
          const url = uploadOss(uploadFile.name, prefix)
          uploadObject(url, uploadFile).then(res => {
            insertFn(res, res, res)
          })
          const message = that.$t('通用.文本.上传成功')
          that.$message.success(message)
        }
      }
      return editorConfig
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
      if (this.value) {
        this.setContent(this.value);
      }
    },
    setContent(value) {
       value = value === null || value === undefined ? '' : value
      if (value) {
        this.editor.setHtml(value)
      }
    },
    onChange(editor) {
      this.currentValue = editor.getHtml()
      this.$emit('input', editor.getHtml())
    },
    valueChange(newValue) {
      newValue = newValue === null || newValue === undefined ? '' : newValue
      this.currentValue = newValue || ''; // 确保不是 null
      if (this.editor) {
        this.setContent(newValue);
      }
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
